import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import MCSLoading from "components/MCSLoading";
import "flag-icon-css/css/flag-icon.min.css";
import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { adminService } from "services/admin.service";
import { useAuthContextUser } from "../../../context/AuthContext";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import ContactSectionType from "_constants/CompanyContactConstants";
import { Form, FormControl } from "@visa/vds";
import Select from 'react-select';
import ContactType from "./Components/ContactType";
import ContactSection from "./Components/ContactSection";
import { DashboardStaffApi } from "services/dashboard.service";
import { FileHelper } from "_helpers/FileHelper";
import { organizationcontactService } from "services/organizationcontact.service";

const AccountInfo = () => {
    const user = useAuthContextUser();
    const isAllowedAdminEdit = user.isSuperAdmin || (user.isExternalUser && user.isCompanyAdmin)
    const isAllowedAdminView = user.isSuperAdmin || user.isToolsAndLibAdmin || (user.isVisaStaff && user.hasVisaInternalExtendedAccess);

    const isReadOnly = user.isToolsAndLibAdmin || (user.isExternalUser && !user.isCompanyAdmin) || (user.isVisaStaff && user.hasVisaInternalExtendedAccess);

    const isAllowedExport = user.isSuperAdmin || (user.isToolsAndLibAdmin && user.hasReportingExport);

    const contactsInitial = {
        technicalContactOne: { contactSection: ContactSectionType.technicalContactOne },
        technicalContactTwo: { contactSection: ContactSectionType.technicalContactTwo },
        businessContactOne: { contactSection: ContactSectionType.businessContactOne },
        businessContactTwo: { contactSection: ContactSectionType.businessContactTwo },
        operationContactOne: { contactSection: ContactSectionType.operationContactOne },
        operationContactTwo: { contactSection: ContactSectionType.operationContactTwo },
        certificateContactOne: { contactSection: ContactSectionType.certificateContactOne },
        certificateContactTwo: { contactSection: ContactSectionType.certificateContactTwo },
        certificateTestContactOne: { contactSection: ContactSectionType.certificateTestContactOne },
        certificateTestContactTwo: { contactSection: ContactSectionType.certificateTestContactTwo },
    }

    const { promiseInProgress } = usePromiseTracker();
    const alertContext = useContext(GlobalAlertContext);
    const [isUVID, setIsUVID] = useState(false);
    const [companyContacts, setCompanyContacts] = useState(null)
    const [countries, setCountries] = useState(null)
    const [organizations, setOrganizations] = useState(null)
    const [toGetContactsOrgId, setToGetContactsOrgId] = useState(null);
    const [resultsObtained, setResultsObtained] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [bid, setBid] = useState(null);

    const {
        control,
        handleSubmit,
        reset,
        getValues,
        register,
        formState: { errors },
    } = useForm();

    const [formData, setFormData] = useState(getValues());
    const updateFormData = () => setFormData(getValues());

    const onSubmit = async (formData) => {
        let contactsList = []
        for (let c in formData) {
            if (formData[c].firstName != undefined) contactsList.push(formData[c])
        }

        const updateContacts = () => {
            return organizationcontactService.UpdateCompanyContacts(toGetContactsOrgId, contactsList)
                .then((res) => {
                    if (res.result.isSuccess) {
                        alertContext.setSuccessMessage("Company Contacts Update Success");
                    } else {
                        alertContext.setErrorMessage("Company Contacts Update Failed");
                    }
                })
                .catch((error) => {
                    alertContext.setErrorMessage("Company Contacts Update Failed");
                })
        }

        trackPromise(updateContacts());
    };

    const GetCompanyContacts = (bid) => {
        organizationcontactService
            .GetCompanyContacts(bid)
            .then((response) => {
                const res = response.result
                setBid(res.bid)
                setIsUVID(res.isUVID)
                setCompanyContacts({
                    technicalContactOne: { ...contactsInitial.technicalContactOne, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.technicalContactOne }) },
                    technicalContactTwo: { ...contactsInitial.technicalContactTwo, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.technicalContactTwo }) },
                    businessContactOne: { ...contactsInitial.businessContactOne, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.businessContactOne }) },
                    businessContactTwo: { ...contactsInitial.businessContactTwo, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.businessContactTwo }) },
                    certificateContactOne: { ...contactsInitial.certificateContactOne, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.certificateContactOne }) },
                    certificateContactTwo: { ...contactsInitial.certificateContactTwo, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.certificateContactTwo }) },
                    certificateTestContactOne: { ...contactsInitial.certificateTestContactOne, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.certificateTestContactOne }) },
                    certificateTestContactTwo: { ...contactsInitial.certificateTestContactTwo, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.certificateTestContactTwo }) },
                    operationContactOne: { ...contactsInitial.operationContactOne, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.operationContactOne }) },
                    operationContactTwo: { ...contactsInitial.operationContactTwo, ...res.companyContacts.find((x) => { return x.contactSection === ContactSectionType.operationContactTwo }) }
                });
                setResultsObtained(true);
            })
            .catch(err => alertContext.setErrorMessage("Something went wrong. Please try again."))
    }

    const handleSelect = (data) => {
        setSelectedOption({ ...data })
        trackPromise(fetchData(data.bid))
    }

    const fetchAllOrg = async () => {
        trackPromise(DashboardStaffApi.getBids()
            .then(result => {
                let x = result.data.result.map((val) => {
                    return {
                        label: `${val.bid}: ${val.organizationName}`,
                        value: `${val.bid}: ${val.organizationName}`,
                        bid: val.bid
                    }
                })
                setOrganizations(x);
            }))
            .catch((error) => {
                console.log(error)
            })
    }

    const fetchData = async (bid) => {
        setResultsObtained(false);
        let fetchDataApi = [
            GetCompanyContacts(bid),
            adminService.GetAllCountries().then((res) => setCountries(res.result)),
        ];

        await trackPromise(Promise.all(fetchDataApi).then((res) => setToGetContactsOrgId(bid)).catch((error) => alertContext.setErrorMessage("Something went wrong. Please try again.")));
    };

    const handleExportClickBtn = () => {
        trackPromise(organizationcontactService.ExportAll()
            .then((res) => {
                FileHelper.DownloadFile(res);
            }))
            .catch((error) => {
                alertContext.setErrorMessage("Export Failed");
            }
            )
    }

    useEffect(() => {
        if (isAllowedAdminView) {
            fetchAllOrg();
        } else {
            fetchData(user.organization.bid);
        }
    }, []);

    useEffect(() => {
        reset(companyContacts);
    }, [companyContacts]);

    useLayoutEffect(() => {
        const inputSelectedOrg = document.getElementById("orgInput")
        if (!inputSelectedOrg) return
        inputSelectedOrg.style.opacity = "1"
    }, [selectedOption])

    return (
        <>
            <GlobalAlertContext.Consumer>
                {(alertObj) => (
                    <>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1" style={{ marginLeft: "-2px" }}>Company Contacts</Typography>
                                </Col>
                                {isAllowedExport &&
                                    <Col>
                                        <ButtonGroup direction="right">
                                            <ButtonText
                                                colorScheme="primary"
                                                type="submit"
                                                onClick={handleExportClickBtn}
                                            >
                                                Export all
                                            </ButtonText>
                                        </ButtonGroup>
                                    </Col>
                                }
                            </Row>
                            {isAllowedAdminView && organizations &&
                                <>
                                    <Row>
                                        <Col>
                                            <FormControl>
                                                <p>Search by BID or Company Name</p>
                                                <Select style={{ height: "auto" }}
                                                    label="BID: Organization"
                                                    value={selectedOption}
                                                    onChange={handleSelect}
                                                    options={organizations}
                                                    inputId="orgInput"
                                                >
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </>
                            }
                            {promiseInProgress && <MCSLoading />}
                            {!promiseInProgress && toGetContactsOrgId && resultsObtained && (
                                <>
                                    {
                                        <>
                                            <Row>
                                                <Form style={{ marginTop: "15px" }}>
                                                    <div style={{ marginBottom: "15px" }}>
                                                        <ContactType style={{ marginBottom: "-10px" }} contactType="Technical Contacts" contactTypeDescription="Responsible for answering questions about specifications, configuration updates, and technology" />
                                                        <Row>
                                                            <Col>
                                                                <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="technicalContactOne" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />
                                                            </Col>
                                                            <Col>
                                                                <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="technicalContactTwo" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />

                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div style={{ marginBottom: "15px" }}>
                                                        <ContactType contactType="Business Contacts" contactTypeDescription="Responsible for receiving communications on Visa Secure program updates and business questions" />
                                                        <Row>
                                                            <Col>
                                                                <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="businessContactOne" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />
                                                            </Col>
                                                            <Col>
                                                                <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="businessContactTwo" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />

                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    {!isUVID &&
                                                        <>
                                                            <div style={{ marginBottom: "15px" }}>
                                                                <ContactType contactType="Operation Contacts" contactTypeDescription="Responsible for receiving operations and service availability related communications" />
                                                                <Row>
                                                                    <Col>
                                                                        <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="operationContactOne" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />
                                                                    </Col>
                                                                    <Col>
                                                                        <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="operationContactTwo" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />

                                                                    </Col>
                                                                </Row>
                                                            </div>

                                                            <div style={{ marginBottom: "15px" }}>
                                                                <ContactType contactType="Certificate Contacts" contactTypeDescription="Responsible for receiving digital certificate reminders, questions or updates" />
                                                                <Row>
                                                                    <Col>
                                                                        <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="certificateContactOne" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />
                                                                    </Col>
                                                                    <Col>
                                                                        <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="certificateContactTwo" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />

                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </>
                                                    }
                                                    <div style={{ marginBottom: "15px" }}>
                                                        <ContactType contactType="Certification Test Contacts" contactTypeDescription="Responsible for receiving certification reminders, test case or testing updates" />
                                                        <Row>
                                                            <Col>
                                                                <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="certificateTestContactOne" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />
                                                            </Col>
                                                            <Col>
                                                                <ContactSection isReadOnly={isReadOnly} errors={errors} control={control} sectionName="certificateTestContactTwo" updateFormData={updateFormData} register={register} countries={countries} getValues={getValues} />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    {isAllowedAdminEdit &&
                                                        <Row>
                                                            <Col>
                                                                <ButtonGroup direction="right">
                                                                    <ButtonText
                                                                        colorScheme="primary"
                                                                        type="submit"
                                                                        onClick={handleSubmit(onSubmit)}
                                                                    >
                                                                        Save
                                                                    </ButtonText>
                                                                </ButtonGroup>
                                                            </Col>
                                                        </Row>
                                                    }
                                                </Form>
                                            </Row>
                                        </>
                                    }
                                </>
                            )}
                        </Grid>
                    </>
                )}
            </GlobalAlertContext.Consumer>
        </>
    );

};

export default AccountInfo;
